import { SuperAdmin_role, ENTERPRISE, DISTRIBUTER, agentRole, DOWNLOAD_URL } from '/src/config/defaultSttings.js'

//下载配置文件
export function get_product_json(product_key) {
	var url = `${DOWNLOAD_URL}pk_json/${product_key}/${product_key}.json?t=${(new Date()).getTime()}`
	console.log(url)
	// 创建一个Promise对象，处理异步操作的机制，异步操作完成时返回结果或错误
	return new Promise(function (resolve, reject) {
		// 创建一个新的 xmlHttpRequest 对象，用于发送http请求
		let xhr = new XMLHttpRequest()
		// 使用 GET 方法打开一个连接指定URL的http请求 
		// 第一个参数时请求方法，使用GET
		// 第二个参数时url，下载的路径
		// 第三个参数时布尔值，请求是否为异步
		xhr.open('get', url, true)
		// 设置响应的数据类型为json
		xhr.responseType = "json"
		// 发送HTTP请求
		xhr.send()
		// 当请求成功接收响应时的回调函数。
		// 回调函数中的代码检查响应的状态码，如果是 200，表示请求成功，调用 resolve 方法并传递响应的 JSON 数据。
		// 如果状态码不是 200，表示请求失败，则调用 resolve 方法并传递字符串 'error'。

		xhr.onload = function () {
			if (this.status == 200) {
				resolve(this.response)

			} else {
				console.log('下载失败');
				resolve('error')
			}
		}
	})
}
export function fileopen_json(product_key) {
	var url = `https://fileopen.di-link.com/customer_files/richu/config_file/${product_key}/${product_key}.json`
	console.log(url)
	// 创建一个Promise对象，处理异步操作的机制，异步操作完成时返回结果或错误
	return new Promise(function (resolve, reject) {
		// 创建一个新的 xmlHttpRequest 对象，用于发送http请求
		let xhr = new XMLHttpRequest()
		// 使用 GET 方法打开一个连接指定URL的http请求 
		// 第一个参数时请求方法，使用GET
		// 第二个参数时url，下载的路径
		// 第三个参数时布尔值，请求是否为异步
		xhr.open('get', url, true)
		// 设置响应的数据类型为json
		xhr.responseType = "json"
		// 发送HTTP请求
		xhr.send()
		// 当请求成功接收响应时的回调函数。
		// 回调函数中的代码检查响应的状态码，如果是 200，表示请求成功，调用 resolve 方法并传递响应的 JSON 数据。
		// 如果状态码不是 200，表示请求失败，则调用 resolve 方法并传递字符串 'error'。

		xhr.onload = function () {
			if (this.status == 200) {
				resolve(this.response)

			} else {
				console.log('下载失败');
				resolve('error')
			}
		}
	})
}
